<template >
  <div class="ShareBtn" >
    <button type="button" name="button" class="forShare" :clstag="clstag" @click="handleClick()">
      <span class="shareText">{{shareBtnText()}}</span>
    </button>
  </div>
</template>

<script>
import * as api from '@/api'
import * as util from "@/public/util.js"
import { getRiskData } from '@/public/getRiskData'

import genShareInfo from '@/public/genShareInfo'
import { jrSharePanel } from '@/public/shareJdjr'
import { scSharePanel } from '@/public/shareJdsc'
import { registerShare } from '@/public/registerShare'

import _ from 'lodash'
const throttleTime = 500

let {
  actCode,
  markId,
  source,
  pin,
} = util.parseUrlSearchToObj()

export default {
  name: 'ShareBtn',
  props:["isBuilder", "isEnd", 'isComplete'],
  data () {
    return {
      shareBtnMaidian: "", //分享按钮的埋点
      canBuildTeam: false, // 是否能建团
      clstag: '', // 埋点
      contents: window.contentData.contents || {},
    }
  },
  mounted () {
    let shareInfo = genShareInfo({
      actCode,
      markId,
      source,
    })
    registerShare(shareInfo)

    api.isBuildTeam({
      reqData:JSON.stringify({
        actCode
      })
    }).then(resultData => {
      let canBuildTeam
      if (resultData.code == '00000zt' || resultData.code == '10014zt') {
        canBuildTeam = true
      }
      this.canBuildTeam = canBuildTeam
    })
  },
  methods: {
    goShare(teamInfo){
      let shareInfo = genShareInfo(teamInfo)
      registerShare(shareInfo)

      if ($.device.jdjr) {
        jrSharePanel(shareInfo)
      }

      if ($.device.jdapp) {
        scSharePanel(shareInfo)
      }
      if ($.device.weixin) {
        this.showPop()
      }
    },

    handleClick: _.throttle(function startShare () {
      let code = 0 // 标识分享状态
      //   0: '发起当前活动',
      //   1: '发起新活动',
      //   2: '查看更多活动',
      if (!this.canBuildTeam) { // 不能建团
        if (this.isEnd || this.isComplete) { // 团不存活
          if (this.isBuilder) { // 是团长
            code = 2
          } else { // 不是团长
            code = 2
          }
        } else { // 团存活
          if (this.isBuilder) { // 是团长
            code = 0
          } else { // 不是团长
            code = 2
          }
        }
      }
      else { // 能建团
        if (this.isEnd || this.isComplete) { // 团不存活
          if (this.isBuilder) { // 是团长
            code = 1
          } else { // 不是团长
            code = 1
          }
        } else { // 团存活
          if (this.isBuilder) { // 是团长
            code = 0
          } else { // 团员
            code = 1
          }
        }
      }

      switch (code) {
        case 0:
          {
            this.clstag = 'jr|keycount|zy|dq_fx'

            let teamInfo = {
              actCode,
              markId,
              source,
              pin,
            }
            this.goShare(teamInfo)
          }
          break;
        case 1:
          {
            // alert(`case1`)
            this.clstag = 'jr|keycount|zy|x_fx'

            api.buildTeam({
              reqData:JSON.stringify({
                actCode,
                source,
                riskDeviceParam: JSON.stringify(getRiskData())
              })
            }).then(teamInfo => {
              this.goShare(teamInfo)
            })
          }
          break
        case 2:
          {
            this.clstag = 'jr|keycount|zy|cx'
            this.seeMoreActivity()
          }
      }
    }, throttleTime),
    showPop(){
      this.$emit('setPopVisible', true)
    },
    shareBtnText () {
      let buttonText
      if (!this.canBuildTeam) { // 不能建团
        // 团成员
        if (!this.isBuilder) {
          if($.device.jdjr){
            buttonText = this.contents.shareBtn.chaoXianIn || ''
          }else {
            buttonText = this.contents.shareBtn.chaoXianOut || ''
          }
          return buttonText
        }
        // 团长
        if (this.isEnd || this.isComplete) { // 团成功,团失败
          if($.device.jdjr){
            buttonText = this.contents.shareBtn.chaoXianIn || ''
          }else {
            buttonText = this.contents.shareBtn.chaoXianOut || ''
          }
        } else { // 团存活
          // buttonText = '继续分享  赢最大红包'
          buttonText = this.contents.shareBtn.leaderLive || ''
        }
      }
      else { // 能建团
        // 团员
        if (!this.isBuilder) {
          // buttonText = '点我分享  再得红包'
          buttonText = this.contents.shareBtn.member || ''
          return buttonText
        }

        // 团长
        if (this.isComplete) { // 团成功
          // buttonText = '继续发红包  赢更多'
          buttonText = this.contents.shareBtn.leaderSucc || ''
        } else if (this.isEnd || this.isComplete) { // 团失败
          // buttonText = '点我开新团 赢99元红包'
          buttonText = this.contents.shareBtn.leaderFail || ''
        } else { // 团存活
          // buttonText = '继续分享  赢最大红包'
          buttonText = this.contents.shareBtn.leaderLive || ''
        }

      }
      return buttonText
    },
    seeMoreActivity(){
      try {
        if(!$.device.jdjr){
          window.location.href = this.contents.shareBtn.chaoXianOutLink
        }else{
          let defer = jsBridgeV3.onReady()
          let link = this.contents.shareBtn.chaoXianInLink

          defer.then(function (res) {
            this.jsOpenWeb({
              jumpUrl: link, // 活动页
              jumpType: 8,
              productId: '',
              isclose: true
            })
          })
        }
      } catch (e) {}
    }
  }
}
</script>

<style lang="scss" scoped>
.ShareBtn{

  .forShare{
    background-image: linear-gradient(111deg, #FF8A51 7%, #FB4242 100%);
    border-radius: 60px;
    width: 285px;
    height: 60px;
    border: none;
    outline: none;
    text-align: center;
    box-shadow: 0px 7px 20px rgba(176, 0, 0, 0.2);
  }
  .shareText{
    // font-family: 'PingFangSC-Semibold';
    font-family: 'PingFang-SC-Regular';
    font-size: 17px;
    color: #FFFFFF;
    font-weight: 600;
  }


}
</style>



// WEBPACK FOOTER //
// src/components/ShareBtn/index.vue